import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Store_category } from '../models/accounting/store/store_category';
import { Store_item } from '../models/accounting/store/store_item';
import { Store_order } from '../models/accounting/store/store_order';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor(private http: HttpClient) { }

  getCategory(horse_show_id: string, category_number: number): Promise<Store_category> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'store/get_store_category/horse_show_id/'+horse_show_id+'/category_number/' + category_number).subscribe((response:any) => {
      if(response.type == 'store_category' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }

  getOrder(order_id: string): Promise<Store_order> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'store/get_store_order/order_id/'+order_id).subscribe((response:any) => {
      if(response.type == 'store_order' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }

}
